// Import model
import { AiAssistant } from '../models/AiAssistant';

// Import base class serializer

// Import dependency types (models and enums used in properties)

// Import dependency serializers (for complex types)

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for AiAssistant - handles JSON serialization and deserialization with type validation
 */
export class AiAssistantSerializer {
  /**
   * Deserializes a JSON string into a AiAssistant instance
   */
  static deserialize(json: string): AiAssistant {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a AiAssistant instance
   */
  static fromObject(obj: any): AiAssistant {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to AiAssistant');
    }


    const instance: AiAssistant = {
      tags: obj['Tags'] ? (obj['Tags'] as any[]).map((item: any) =>
        item as string
      ) : [] as any,
      isActive: obj['IsActive'] as boolean | undefined,
      profileIds: obj['ProfileIds'] ? (obj['ProfileIds'] as any[]).map((item: any) =>
        item as string
      ) : [] as any,
      role: obj['Role'] as string | undefined,
      createdDate: obj['createdDate'] as string | undefined,
      id: obj['_id'] as string | undefined,
      name: obj['name'] as string | undefined,
      description: obj['description'] as string | undefined,
      entityId: obj['entityId'] as string | undefined,
      entityIdName: obj['entityId|Name'] as string | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of AiAssistant instances
   */
  static deserializeArray(json: string): AiAssistant[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a AiAssistant instance to a JSON string
   */
  static serialize(instance: AiAssistant): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a AiAssistant instance to a plain object
   */
  static toObject(instance: AiAssistant): any {
    return {
      'Tags': instance.tags?.map((item: any) =>
        item
      ),
      'IsActive': instance.isActive,
      'ProfileIds': instance.profileIds?.map((item: any) =>
        item
      ),
      'Role': instance.role,
      'createdDate': instance.createdDate,
      '_id': instance.id,
      'name': instance.name,
      'description': instance.description,
      'entityId': instance.entityId,
      'entityId|Name': instance.entityIdName,
    };
  }

  /**
   * Serializes an array of AiAssistant instances to a JSON string
   */
  static serializeArray(instances: AiAssistant[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
